module.exports = __webpack_public_path__ + "static/media/avive_appuser_accepted_active.c36636df.svg";